import { IsBoolean, IsOptional, IsString } from 'class-validator';

export class CreateReturnsProcessConfigRequestDto {
    /**
     * Does Client have a NO RETURN Policy?
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    hasNoReturnPolicy?: boolean;

    /**
     * Is the 3PL/Warehouse's Returns Form Used?
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    usesWarehouseReturnsForm?: boolean;

    /**
     * Comments for NO RETURN Policy
     * @example 'Potential return to stock after assessment by Q&C. Note no return to stock is permitted for sterile products.'
     */
    @IsOptional()
    @IsString()
    noReturnPolicyComments?: string;

    /**
     * Comments for 3PL/Warehouse Returns Form
     * @example 'For a potential return to stock, Q&C uses Returned Product Form QR-022, using Lynden Product Return Inspection Report W-022 as a supporting document.'
     */
    @IsOptional()
    @IsString()
    warehouseReturnsFormComments?: string;

    /**
     * Notes
     * @example 'Where a temperature excursion (or potential excursion) is associated with the return, refer to Section 3.7 of this client information record.'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
